import GeneratePDFDialog from './GeneratePDFDialog';

export default GeneratePDFDialog;
